module.exports = __webpack_public_path__ + "static/img/sm_js_10.0ad69ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sm/sm_js_10.png
// module id = 4OEM
// module chunks = 1